<div class="container">
  <div class="mt-3 image-row d-none d-md-flex position-relative justify-content-center">
    <div class="standard-height column-padding mr-3"
      [ngClass]="{ 'col-md-12 col-xl-12 text-center': images.length == 1 }">
      <img class="img-fluid standard-height img-cover first-image cursor-pointer"
        [ngClass]="{ 'top-right-image bottom-right-image': images.length == 1 }" [src]="images[0]"
        (click)="openModal(content, 0)" />
    </div>
    <div class="standard-height" *ngIf="images.length > 1">
      <div class="row mb-2">
        <div class="col-xl-6 column-padding" [class.col-xl-12]="images.length == 2">
          <img class="img-fluid small-image-height img-cover tablet-top-right-image cursor-pointer" [src]="images[1]"
            (click)="openModal(content, 1)" />
        </div>
        <div class="d-none d-xl-block col-xl-6 column-padding">
          <img class="img-fluid small-image-height img-cover top-right-image cursor-pointer" [src]="images[2]"
            (click)="openModal(content, 2)" />
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 column-padding">
          <img class="img-fluid small-image-height img-cover tablet-bottom-right-image cursor-pointer" [src]="images[3]"
            (click)="openModal(content, 3)" />
          <div class="more-photos-container d-xl-none" *ngIf="images.length > 3">
            <button type="button" (click)="openModal(content)" class="btn btn-white btn-more-photos"
              id="viewMorePhotos">View photos</button>
          </div>
        </div>
        <div class="d-none d-xl-block col-md-6 column-padding">
          <img class="img-fluid small-image-height img-cover bottom-right-image cursor-pointer" [src]="images[4]"
            (click)="openModal(content, 4)" />
          <div class="more-photos-container" *ngIf="images.length > 5">
            <button type="button" (click)="openModal(content)" class="btn btn-white btn-more-photos"
              id="viewMorePhotos">View photos</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-md-none">
  <swiper [config]="imageSwipeConfig">
    <div *ngFor="let image of images">
      <img class="img-fluid border-0" [src]="image" />
    </div>
  </swiper>
</div>

<ng-template #content let-modal>
  <div>
    <div class="position-relative">
      <div class="close-photo-gallery px-3 py-2 cursor-pointer" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <i class="icon-close text-white"></i>
      </div>
    </div>
    <swiper [config]="imageSwipeConfig" [(index)]="modalIndex">
      <div *ngFor="let image of images">
        <img class="img-fluid border-0 w-100" [src]="image" />
      </div>
    </swiper>
  </div>
</ng-template>